import EventEmitter from 'events';

const eventEmitter2 = new EventEmitter();

export default eventEmitter2;
